import { Injectable } from '@angular/core';
import { AlertOption, BehaviorSubject, Observable } from '../models';

@Injectable()
export class MainService {

  private readonly messageOptions: BehaviorSubject<AlertOption> = new BehaviorSubject<AlertOption>(null);

  public breadcrumbs = [];

  constructor() { }

  alertMessage(option: AlertOption) {
    this.messageOptions.next(option);
  }

  get alert(): Observable<AlertOption> {
    return this.messageOptions.asObservable();
  }

  search(data: any[], f): any[] {
    if (!f) {
      return data;
    }
    const controls = Object.keys(f).filter(control => f[control]);
    if (controls.length) {
      return data.filter(r => {
        return controls.every(control =>
          control === 'name' ? String(r.firstName + ' ' + r.lastName).toLowerCase().includes(String(f.name).toLowerCase())
          : !isNaN(f[control].toString()) ? +r[control] === +f[control]
          : !!new Date(r[control]).getTime() ? new Date(r[control]).toDateString() === new Date(f[control]).toDateString()
          : String(r[control]).toLowerCase().includes(String(f[control]).toLowerCase())
        );
      });
    } else {
      return data;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/main.service.ts